export const apiUrl = import.meta.env.VITE_API_URL;
export const appUrl = import.meta.env.VITE_PUBLIC_APP_URL;
